<template>
  <q-dialog v-model="showDetail">
    <q-card square>
      <q-card-section class="result-title">
        <div class="title-text">Detailed Payment Schedule</div>
        <i class="fas fa-times" @click="showDetail = false">
          <q-tooltip>Close</q-tooltip>
        </i>
      </q-card-section>
      <q-card-section style="max-height: 35vh" class="scroll">
        <table class="detailed-calculate-result-1">
          <thead>
            <tr>
              <th v-for="(item, index) in head" :key="index">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in financeArr" :key="index">
              <td>{{ index + 1 }}</td>
              <td v-if="type !== 'Finance'">
                {{ currencyConventer(item.principle) }}
              </td>
              <td v-if="type === 'Finance'">
                {{ currencyConventer(item.amount) }}
              </td>
              <td>{{ currencyConventer(item.payment) }}</td>
              <td v-if="type !== 'Finance'">
                {{ currencyConventer(item.depreciation_amount) }}
              </td>
              <td v-if="type === 'Finance'">
                {{ currencyConventer(item.interest) }}
              </td>
              <td v-if="type === 'Finance'">
                {{ currencyConventer(item.principle) }}
              </td>
              <td>{{ currencyConventer(item.payoff) }}</td>
            </tr>
          </tbody>
        </table>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
export default {
  props: {
    type: String,
  },
  computed: {
    head() {
      if (this.type !== "Finance")
        return ["Month", "Principal", "Payment", "Depr. Amount", "Payoff"];
      else
        return [
          "Month",
          "Loan Amount",
          "Payment",
          "Interest",
          "Principle",
          "Payoff",
        ];
    },
    currencyConventer() {
      return (val) => {
        if (val) {
          return val.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
          });
        } else return 0;
      };
    },
    showDetail: {
      get() {
        return this.$store.state.calculator.showDetail;
      },
      set(val) {
        this.$store.commit("calculator/SHOW_DETAILED", val);
      },
    },
    financeArr: {
      get() {
        return this.$store.state.calculator.financeArr;
      },
      set(val) {
        this.$store.commit("calculator/SET_PAYMENT_DETAILS", val);
      },
    },
  },
};
</script>
<style lang="scss">
.result-title {
  display: flex;
  flex-flow: row nowrap;
  background-color: rgb(2, 123, 227);
  color: #fff;
  align-items: center;
  padding: 15px;
  .title-text {
    font-weight: 700;
    font-size: 20px;
    flex: 1;
  }
  i {
    cursor: pointer;
  }
}
.detailed-calculate-result-1 {
  border-collapse: collapse;
}
.detailed-calculate-result-1 {
  tr,
  td,
  th {
    padding: 3px;
    border: 1px solid #ccc;
    text-align: center;
  }
  td {
    font-weight: 300;
  }
}
</style>